var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('el-overlay-loading',{attrs:{"loading":_vm.pageloading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }